import { resolveShipmentStatusDisplay } from '@ztechapps/logistic.common'
import { StatusColorBadge } from '@ztechapps/webui.util'

export type LogisticShipmentStatusBadgeProps = { status: string }

export const LogisticShipmentStatusBadge = ({ status }: LogisticShipmentStatusBadgeProps) => {
  const display = resolveShipmentStatusDisplay(status)

  return <StatusColorBadge status={display.label} color={display} />
}
